import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { LightningModalTypes } from '../../core/classes/modal-types.enum';

@Component({
  selector: 'app-tod-booking-error-modal',
  templateUrl: './tod-booking-error-modal.component.html',
  styleUrls: ['./tod-booking-error-modal.component.scss'],
  standalone: false
})
export class TodBookingErrorModalComponent implements OnInit {
  constructor(public activeModal: NgbActiveModal) {}

  stationCode: string = null;
  stationName: string = null;

  ngOnInit(): void {}
}

LightningModalTypes.TodBookingErrorModalComponent.component = TodBookingErrorModalComponent;
